import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions';
import getters from './getters.js';
import mutations from './mutations.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    articles: null,
    auth_base64: null,
    cart: null,
    cartStatus: null,
    countries: null,
    isDeliveryEmpty: false,
    isLoadingCart: true,
    linesCart: [],
    linesCartLength: 0,
    gammes: null,
    headerTitle: null,
    ordersListV2: null,
    token: null,
    user: null,
  },
  actions,
  getters,
  mutations
})
